import { useMobile } from "@/hooks";
import {
  Button,
  Modal,
  SuccessFilled,
} from "@monsterindia/global-ui-components";
import React from "react";

const ToggleOffInfoPopUp: React.FC<ToggleOffInfoPopUpProps> = ({
  showModal,
  handleCloseModal,
  handleToggleOff,
  mobileHeading,
  mainHeadingMessage,
  infoMessages,
  secondaryBtnLabel,
}) => {
  const isMobile = useMobile();

  return (
    <>
      <Modal
        screenAlignment={isMobile ? "bottom-sheet" : "center"}
        showModal={showModal}
        closeModal={handleCloseModal}
        showCloseButton={true}
        showHandleBar={isMobile ? true : false}
        customClass="!px-0 !py-2 !h-max"
      >
        <>
          {isMobile && (
            <>
              <div className="px-3 py-2 text-base font-bold">
                {mobileHeading}
              </div>
              <div className="bg-border-moderate h-[1px] w-full"></div>
            </>
          )}

          <div className="flex min-h-[18rem] w-[360px] flex-col gap-5 p-4">
            <div className="text-base font-bold leading-normal text-gray-900">
              {mainHeadingMessage}
            </div>
            {infoMessages?.map((message, index) => (
              <div
                key={index}
                className="inline-flex items-center justify-start gap-2 rounded-lg px-1"
              >
                <SuccessFilled width="14" height="14" fill="#228568" />
                <div className="shrink grow basis-0 text-xs font-normal leading-none text-black">
                  {message}
                </div>
              </div>
            ))}
          </div>
          <div className="fixed bottom-1 flex w-full justify-around gap-5 p-4">
            <Button
              onClick={handleCloseModal}
              label={secondaryBtnLabel}
              modifier="secondary"
            />
            <Button
              onClick={handleToggleOff}
              label="Disable"
              modifier="primary"
              size="lg"
              className="flex flex-grow items-center justify-center gap-1 px-4 py-3"
            />
          </div>
        </>
      </Modal>
    </>
  );
};

export default ToggleOffInfoPopUp;
